/**
 * PROSHOP — Annuaire « Nos marques » (recherche live + filtre catégories + A→Z).
 * Un fichier par fonctionnalité (convention projet).
 */
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.pdw-brands-page');
    if (!root) {
        return;
    }

    const searchInput = root.querySelector('#pdw-brands-search-input');
    const chips = Array.from(root.querySelectorAll('.pdw-brands-chip'));
    const items = Array.from(root.querySelectorAll('.pdw-brands-item'));
    const groups = Array.from(root.querySelectorAll('.pdw-brands-group'));
    const alphaLinks = Array.from(root.querySelectorAll('.pdw-brands-alpha-link'));
    const emptyMsg = root.querySelector('.pdw-brands-empty');

    let query = '';
    const activeCats = new Set();

    const apply = () => {
        let visibleTotal = 0;

        items.forEach((item) => {
            const name = item.dataset.name || '';
            const cats = (item.dataset.cats || '').split(' ').filter(Boolean);
            const matchSearch = !query || name.includes(query);
            const matchCat = activeCats.size === 0 || cats.some((c) => activeCats.has(c));
            const visible = matchSearch && matchCat;
            item.hidden = !visible;
            if (visible) {
                visibleTotal++;
            }
        });

        // Masque les groupes (lettres) sans résultat + maj de l'index A→Z
        groups.forEach((group) => {
            const letter = group.dataset.letter;
            const hasVisible = group.querySelector('.pdw-brands-item:not([hidden])') !== null;
            group.hidden = !hasVisible;
            const link = alphaLinks.find((l) => l.textContent.trim() === letter);
            if (link && link.classList.contains('pdw-brands-alpha-link')) {
                link.classList.toggle('is-disabled', !hasVisible && !link.classList.contains('is-empty'));
            }
        });

        if (emptyMsg) {
            emptyMsg.hidden = visibleTotal !== 0;
        }
    };

    if (searchInput) {
        searchInput.addEventListener('input', () => {
            query = searchInput.value.trim().toLowerCase();
            apply();
        });
    }

    chips.forEach((chip) => {
        chip.addEventListener('click', () => {
            const cat = chip.dataset.cat;
            if (activeCats.has(cat)) {
                activeCats.delete(cat);
                chip.classList.remove('is-active');
            } else {
                activeCats.add(cat);
                chip.classList.add('is-active');
            }
            apply();
        });
    });
});
